import React from 'react';
import cx from 'classnames';
import { Tabs, TabsProps } from 'antd';

import styles from './LrvTabs.module.scss';

export interface LrvTabsProps extends TabsProps {
  theme?: 'dark' | 'light';
}

export const LrvTabs = (props: LrvTabsProps) => {
  const { className, theme = 'dark' } = props;
  const isDarkTheme = theme === 'dark';

  const lrvProps = {
    ...props,
    className: cx(isDarkTheme ? styles.darkTabs : styles.lightTabs, className),
  };

  return (
    <Tabs {...lrvProps}>
    </Tabs>
  );
};
